// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.my-panel[data-v-43d499d4] {\n  border: 1px solid #ccc;\n  margin-bottom: 1em;\n}\n.my-panel[data-v-43d499d4]:first-of-type {\n    margin-top: 1em;\n}\n.my-panel[data-v-43d499d4]:last-of-type {\n    margin-bottom: 0;\n}\n.my-panel-heading[data-v-43d499d4] {\n  padding: 0.5em 1em;\n  background: #fafaec;\n  margin-bottom: 0;\n}\n.my-panel-body[data-v-43d499d4] {\n  padding: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
